import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-7',
  templateUrl: './7.component.html',
  styleUrls: ['./7.component.scss'],
})
export class VbList7Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
